import React from 'react'
import { Container } from 'react-bootstrap';

import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';

export const Testimonial = () => {

    const testimonial =[
        {
          name: 'Priya Menon ',
          role: 'CLIENT',
          describe: "IMUII helped us completely revamp our online store with a custom e-commerce platform. Sales have doubled since launch, and the UI is intuitive and fast. Truly a game-changer for our business." ,
          img: '/assets/images/no-img.jpg',
          quote: '/assets/images/quote.svg'
        },
        {
          name: 'Dr. Karan Mehta ',
          role: 'CLIENT',
          describe: "We approached IMUII to build a secure telemedicine app for our clinic network. They delivered beyond expectations—HIPAA-compliant, smooth UX, and exceptional post-launch support." ,
          img: '/assets/images/no-img.jpg',
          quote: '/assets/images/quote.svg'
        },
        {
          name: 'Rahul Deshpande ',
          role: 'CLIENT',
          describe: "Their backend architecture and dashboard for our fintech platform are rock solid. Fast, scalable, and built with foresight. IMUII is more of a tech partner than just a vendor." ,
          img: '/assets/images/no-img.jpg',
          quote: '/assets/images/quote.svg'
        },
        {
          name: 'Neha Kapoor ',
          role: 'CLIENT',
          describe: "We were a team of three with just an idea. IMUII helped us wireframe, prototype, and build our MVP with sleek UI/UX. They’re startup-friendly and move at startup speed." ,
          img: '/assets/images/no-img.jpg',
          quote: '/assets/images/quote.svg'
        },
        {
          name: 'Anand Iyer ',
          role: 'CLIENT',
          describe: "Our outdated LMS needed a full overhaul. IMUII brought in a modern CMS, integrated it with our tools, and simplified content delivery for students. Highly recommend for ed-tech projects." ,
          img: '/assets/images/no-img.jpg',
          quote: '/assets/images/quote.svg'
        }
    ]

    

  return (
    <section className='testimonial_section'>
      <div className='testi-shap-1'>
        <img src="../assets/images/testi-shap-1.png" alt="" />
      </div>
      <div className='testi-shap-2'>
        <img src="../assets/images/testi-shap-2.png" alt="" />
      </div>
      <Container>
        <h5 className='service-text' data-aos="fade-right" data-aos-duration="3000">Trusted Clients Feedback</h5>

        <div className='testi-flex'>
          <div data-aos="fade-right" data-aos-duration="3000">
            <h4>Why People <span className='say-text'>Say About</span> Our Services</h4>
          </div>
        </div>

        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={false}
          navigation={true}
          modules={[Navigation, Pagination, EffectCoverflow, Autoplay]}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            600: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
          className="mySwiper testimonial-swiper"
        >
          {
            testimonial.map((client,index)=>(
              <SwiperSlide key={index}>
                <div className='testi-card'>
                  <div className='testi-img'>
                    <img src={client.img} alt="" />
                  </div>
                  <div className='quote-img'>
                    <img src={client.quote} alt="" />
                  </div>
                  <div className='testi-text'>
                    <h3>{client.name}</h3>
                    <h6>{client.role}</h6>
                    <p>{client.describe}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))
          }
        </Swiper>
      </Container>

    </section>
  )
}
